import { Box, Stack, Typography } from "@mui/joy";
import { theme } from "../../../components/Theme";

type Props = {
  currentStep: number;
  totalStep: number;
  nextStep: string;
};

const OnboardingStepper = ({ currentStep, totalStep, nextStep }: Props) => {
  return (
    <Stack
      direction={"column"}
      sx={{
        px: "16px",
        pb: "40px",
        gap: "8px",
      }}
    >
      {/* step details */}
      <Stack
        direction={"row"}
        sx={{
          justifyContent: "space-between",
        }}
      >
        {/* step currentStep out of totalStep */}
        <Typography
          level="text-xs-medium"
          textColor={theme.palette.neutral[600]}
        >
          Step {currentStep} out of {totalStep}
        </Typography>

        {/* next step */}
        <Typography
          level="text-xs-medium"
          textColor={theme.palette.neutral[500]}
        >
          {nextStep}
        </Typography>
      </Stack>

      {/* progress bar */}
      <Stack direction={"row"} gap={"4px"}>
        {Array.from({ length: totalStep }, (_, index) => (
          <Box
            key={index}
            sx={{
              width: {
                xs:
                  index + 1 !== currentStep
                    ? `${66 / (totalStep - 1)}%`
                    : "34%",
                lg: `${98 / totalStep}%`,
              },
              height: "8px",
              backgroundColor:
                index + 1 !== currentStep
                  ? theme.palette.neutral[300]
                  : theme.palette.primary[500],
              borderRadius: "8px",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default OnboardingStepper;
